<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">金币账单明细</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证总状态：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>收支：</label>
          <el-select v-model="incomeType" @change="changeSelectType" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in incomeTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>收支类型：</label>
          <el-select v-model="type" placeholder="Select" style="width: 10em" @change="changeType">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item" v-show="type === 99">
          <label>任务：</label>
          <el-select v-model="taskType" placeholder="Select" style="width: 10em">
            <el-option v-for="item in taskTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="操作时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
<!--          <el-checkbox style="margin-left: 8px;" v-model="limitState">限制</el-checkbox>-->
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; justify-content: space-between; flex: 1">
          <SearchUidOrPhone :type="4" @confirm="openDialog($event)"/>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
        >
          <!--          <el-table-column type="selection" width="55" />-->
          <el-table-column property="createTime" label="操作时间" v-if="checkColList.indexOf('操作时间') > -1" />
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="120">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth"/>
            </template>
          </el-table-column>
          <el-table-column label="状态" v-if="checkColList.indexOf('状态') > -1" width="180">
            <template #default="scope">
              <p>信息审核：{{scope.row.resumeState == 0 ? "未查看" : scope.row.resumeState == 1 ? "待审核" : scope.row.resumeState == 2 ? "已通过" : scope.row.resumeState == 3 ? "不通过" : "--"}}</p>
              <p>身份证认证：{{scope.row.identityAuth.overallAuthState == 0 ? "未提交" : scope.row.identityAuth.overallAuthState == 1 ? "待审核" : scope.row.identityAuth.overallAuthState == 2 ? "审核通过" : scope.row.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
              <p>微信审核：{{scope.row.wechatState == 0 ? '未提交' : scope.row.wechatState == 1 ? '待审核' : scope.row.wechatState == 2 ? '已通过' : scope.row.wechatState == 3 ? '不通过' : '--'}}</p>
              <p>是否是vip：{{scope.row.vipState == 0 ? '否' : scope.row.vipState == 1 ? '是' : scope.row.vipState == 2 ? '是' : '--'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="类型" v-if="checkColList.indexOf('类型') > -1">
            <template #default="scope">
              {{scope.row.type>0?'收入':scope.row.type<0?'支出':'--'}}
            </template>
          </el-table-column>
          <el-table-column property="typeName" label="收支类型" v-if="checkColList.indexOf('收支类型') > -1"></el-table-column>
          <el-table-column property="taskName" label="任务" v-if="checkColList.indexOf('任务') > -1"></el-table-column>
          <el-table-column property="num" label="数量" v-if="checkColList.indexOf('数量') > -1"></el-table-column>
          <el-table-column property="billName" label="账单名字" v-if="checkColList.indexOf('账单名字') > -1"/>
          <el-table-column property="balance" label="操作后余额" v-if="checkColList.indexOf('操作后余额') > -1" />
          <el-table-column property="currentBalance" label="实时余额" v-if="checkColList.indexOf('实时余额') > -1" />
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
        <el-table
            ref="multipleTableRef"
            :data="dataSummary"
            style="width: 40em;margin-top: -24px"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
        >
          <el-table-column property="" label="以上汇总"/>
          <el-table-column property="in_sum" label="总收入"/>
          <el-table-column property="out_sum" label="总支出"/>
          <el-table-column property="collect" label="总数量"/>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import SearchUidOrPhone from '../../components/SearchUidOrPhone'
import {getGoldDetailPageList, getGoldDetailType, goldSummaryCurrentStat} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import GoldDetailDialog from "@/views/gold/components/GoldDetailDialog";
import ImgViewer from '../../assets/js/imageViewer'
import {auth, common} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";

export default {
  name: "GoldDetail",
  components: { DatePickerRange, SearchComponents, SearchUidOrPhone, UserLog },
  data() {
    return {
      // operateState: JSON.parse(sessionStorage.getItem('operateState')), //积分/金币权限

      limitState: false,

      sexArray: common.sexList,
      sex: common.sexList[1]['value'],

      overallAuthStateArray: auth.overallAuthStateList,
      overallAuthState: auth.overallAuthStateList[3]['value'],

      incomeTypeArray: [
        {label: '不限', value: 0},
        {label: '收入', value: 1},
        {label: '支出', value: 2},
      ],
      incomeType: 0,

      typeArray: [
        {label: '不限', value: 0},
      ],
      type: 0,

      typeList: [],
      inList: [],
      outList: [],
      taskTypeList: [],

      taskTypeArray: [
        {label: '不限', value: 0},
      ],
      taskType: 0,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['操作时间', '头像', '用户信息', '状态', '类型', '收支类型', '任务', '数量', '账单名字', '操作后余额', '实时余额', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
      ],

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.sex = 1;
      this.incomeType = 0;
      this.type = 0;
      this.taskType = 0;
      this.overallAuthState = 2;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    changeSelectType() {
      this.type = 0;
      this.taskType = 0;
      this.typeArray = [
        {label: '不限', value: 0},
      ];
      if ( this.incomeType == 1 ) {
        this.typeArray.push.apply(this.typeArray, this.inList)
      } else if ( this.incomeType == -1 ) {
        this.typeArray.push.apply(this.typeArray, this.outList)
      }
    },

    changeType() {
      if ( this.type != 99 ) {
        this.taskType = 0
      }
    },

    //明细类别
    getDetailType() {
      getFormData(getGoldDetailType).then((data) => {
        let { code } = data;
        if(code == 200) {
          this.typeList = data.data.goldTypeList;
          this.typeList.map(item => {
            let obj = {}
            obj.label = item.name
            obj.value = item.type
            if(item.type > 0) {
              this.inList.push(obj)
            }else {
              this.outList.push(obj)
            }
          })
          this.taskTypeList = data.data.goldTaskTypeList;
          this.taskTypeList.map(item => {
            let obj = {}
            obj.label = item.name
            obj.value = item.type
            this.taskTypeArray.push(obj)
          })
        }
      })
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
          // this.getSummarydata();
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['earningType'] = this.incomeType;
      param['type'] = this.type;
      param['taskType'] = this.taskType;
      param['overallAuthState'] = this.overallAuthState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      // param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getGoldDetailPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          let obj = {
            in_sum: 0,
            out_sum: 0,
            collect: 0
          }
          this.pageDataList.map(item => {
            if ( item.num > 0) {
              obj.in_sum += item.num
            }else {
              obj.out_sum += item.num
            }
          })
          obj.collect = obj.in_sum + obj.out_sum
          this.dataSummary = []
          this.dataSummary.push(obj)
          // this.pageDataList.forEach((item,index) => {
          //   for ( let i = 0; i<this.typeList.length; i++) {
          //     if ( item.type == this.typeList[i].type ) {
          //       this.pageDataList[index].type_title = this.typeList[i].title
          //       break
          //     }
          //   }
          //   for ( let j = 0; j<this.taskTypeList.length; j++) {
          //     if ( item.taskType == this.taskTypeList[j].type ) {
          //       this.pageDataList[index].task_title = this.taskTypeList[j].title
          //       break
          //     }
          //   }
          // })
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }


    },

    openDialog(e) {
      Dialog.open({
        component: GoldDetailDialog,
        data: {
          goldDetailForm: e,
          width: '600px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    getSummarydata() {
      let param = {};
      param['sex'] = this.sex;
      param['incomeType'] = this.incomeType;
      param['type'] = this.type;
      param['taskType'] = this.taskType;
      param['baiduAuthState'] = this.baiduAuthState;
      param['baiduMatchState'] = this.baiduMatchState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      getFormData(goldSummaryCurrentStat, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.dataSummary = []
          this.dataSummary.push(data.data)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getDetailType();
    this.getPage(true);
    // this.getSummarydata();
  }
}
</script>

<style scoped>

</style>
